
  /**
   * booking Group
   * @param fb : FormBuilder
   */
export function bookingGroup(fb: any): any {
    return fb.group(
        {
            distributor: fb.control([]),
            owner: fb.control([]),
            creation: fb.group({
                min: fb.control(''),
                max: fb.control('')
            }),
            query: fb.control(''),
            status: fb.control([])
        });
}
